import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  userInfo: object | null;
}

const initialState: UserState = {
  userInfo: null,
};

export const CustomerProductSlice = createSlice({
  name: 'customerProduct',
  initialState,
  reducers: {
    setAdminAuthInfo: (state, action: PayloadAction<UserState>) => {
      state.userInfo = action.payload;
    },
  },
});

export const { setAdminAuthInfo } = CustomerProductSlice.actions;
export default CustomerProductSlice.reducer;
